import { Table } from "antd";
import moment from "moment";
import React, { useState, useEffect } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { FaEyeSlash, FaEye } from "react-icons/fa";
import { AlertConfirm } from "../../../../util/Alert";
import { axios } from "../../../../../utils/useAxios";

export default function TableRemark() {
  const remark = useSelector((state) => state.ethics.form.remark, shallowEqual);
  const [remarkList, setRemarkList] = useState(remark || []);

  useEffect(() => {
    setRemarkList(remark || []);
  }, [remark]);

  return (
    <Table
      size="small"
      bordered={false}
      dataSource={remarkList}
      rowKey="id"
      pagination={false}
    >
      <Table.Column
        title="#"
        align="right"
        dataIndex="row_id"
        className="font-size-12"
        width={5}  
      />
      <Table.Column
        title="หมายเหตุ"
        dataIndex="remark"
        className="font-size-12"
        width={150}  
      />
      <Table.Column
        title="ผู้เขียน"
        align="center"
        dataIndex="create_by"
        className="font-size-12"
        width={50}  
      />
      <Table.Column
        title="วันที่"
        align="center"
        dataIndex="create_date"
        render={(text) => moment(text).format("DD/MM/YYYY HH:mm")}
        className="font-size-12"
        width={50}  
      />
      <Table.Column
        title="การมองเห็น"
        key="action"
        width={50}
        render={(_, record) => {
          const toggleVisibility = async (v) => {
            const confirm = await AlertConfirm(
              v ? "เปิดการมองเห็น" : "ปิดการมองเห็น"
            );
            if (!confirm) return;

            const res = await axios.post("/ethics/remark-visible", {
              id: record.id,
              pos_visible: v ? 1 : 0,
            });

            if (res.status === 200) {
              setRemarkList((i) =>
                i.map((item) =>
                  item.id === record.id
                    ? { ...item, pos_visible: v }
                    : item
                )
              );
            }
          };

          return (
            <div
              style={{ display: "flex", justifyContent: "center" }}
              onClick={(e) => e.stopPropagation()}
            >
              {record.pos_visible ? (
                <div
                  style={{ cursor: "pointer", marginLeft: 10 }}
                  onClick={() => toggleVisibility(false)}
                >
                  <FaEye />
                </div>
              ) : (
                <div
                  style={{ cursor: "pointer", marginLeft: 10 }}
                  onClick={() => toggleVisibility(true)}
                >
                  <FaEyeSlash />
                </div>
              )}
            </div>
          );
        }}
      />
    </Table>
  );
}
